// Full-screen phone dialogs in team chat (new chat, add people, media) and the
// conversation details (reminders): an
// iOS navigation bar with Cancel on the left, a centred title and the main
// action on the right, then a body that fills the rest and scrolls. All
// max-md:, so wide layouts keep the centred dialog. Pair with
// <DialogContent mobileVariant="fullscreen">.
export const PHONE_DIALOG_CLASS =
	'max-md:flex max-md:flex-col max-md:gap-0 max-md:overflow-hidden max-md:p-0';

export const PHONE_DIALOG_HEADER_CLASS =
	'max-md:grid max-md:min-h-12 max-md:shrink-0 max-md:grid-cols-[1fr_auto_1fr] max-md:items-center max-md:space-y-0 max-md:border-b max-md:border-border/60 max-md:px-1.5 max-md:pb-0.5 max-md:pt-[max(0.25rem,var(--safe-top))] max-md:text-center';

export const PHONE_DIALOG_TITLE_CLASS =
	'max-md:truncate max-md:text-[17px] max-md:font-semibold max-md:leading-tight';

export const PHONE_DIALOG_BODY_CLASS =
	'max-md:min-h-0 max-md:flex-1 max-md:overflow-y-auto max-md:overscroll-contain max-md:pb-[max(1rem,var(--safe-bottom))] max-md:kb-open:pb-4';
